
export const checkHover = (e: MouseEvent, target: Element): boolean => {
  const event = e;
  const relatedTarget = event.relatedTarget as HTMLElement;

  if (event.type === "mouseover") {
    // 检查鼠标是否从目标外部移动到目标上
    return !contains(target, relatedTarget) && relatedTarget !== target;
  } else {
    // 检查鼠标是否从目标上移到目标外部
    return !contains(target, relatedTarget) && relatedTarget !== target;
  }
}

export const contains = (parent: Element, child: Element | null): boolean => {
  if (!parent || !child) return false;
  return parent.contains(child);
}
